// S4AB (2026-10-22): Section 4 is two onboarding steps, 4A (compliance, background check
// classification) and 4B (HR, background check upload). One reading of them for every screen.
//
// The server sends section4a_completed and section4b_completed (services/section4_split.py). A
// payload without them (an older response) falls back to section4_completed, which is how a form
// completed before this build reads: the old Section 4 did both jobs in one submit.

export const s4aDone = (ns) => !!(ns && (ns.section4a_completed ?? ns.section4_completed));
export const s4bDone = (ns) => !!(ns && (ns.section4b_completed ?? ns.section4_completed));

// The onboarding steps in order: Sections 1, 2 and 3, then 4A and 4B.
export const ONBOARDING_STEP_COUNT = 5;
export const onboardingSteps = (ns) => (ns
  ? [!!ns.section1_completed, !!ns.section2_completed, !!ns.section3_completed, s4aDone(ns), s4bDone(ns)]
  : [false, false, false, false, false]);
export const onboardingDoneCount = (ns) => onboardingSteps(ns).filter(Boolean).length;
